module.exports = __webpack_public_path__ + "static/media/car-bg.52dd6555.svg";